/**
 * The Rotom Phone's app icons: pixel glyphs on an 8×8 grid, drawn as SVG rects so they stay crisp at any
 * size and follow no image request. Each glyph is rows of characters, `#` a lit pixel, `.` none — the same
 * notation `scripts/gui/` uses for the in-game menu art.
 */

const GLYPHS = {
  music: ['....##..', '....###.', '....#.##', '....#..#', '....#...', '.####...', '#####...', '.###....'],
  stats: ['........', '......##', '......##', '...##.##', '...##.##', '##.##.##', '##.##.##', '........'],
  map: ['..####..', '.#....#.', '#..##..#', '#..##..#', '.#....#.', '..#..#..', '...##...', '........'],
  settings: ['...##...', '.#.##.#.', '..####..', '###..###', '###..###', '..####..', '.#.##.#.', '...##...'],
  quests: ['.######.', '.#....#.', '.#.##.#.', '.#....#.', '.#.##.#.', '.#....#.', '.######.', '........'],
  mail: ['........', '########', '##....##', '#.#..#.#', '#..##..#', '#......#', '########', '........'],
  tower: ['..#..#..', '..####..', '..#..#..', '..####..', '.##..##.', '.######.', '.##..##.', '########'],
  console: ['########', '#......#', '#.#....#', '#..#...#', '#.#..###', '#......#', '########', '..####..'],
  home: ['...##...', '..####..', '.######.', '########', '.##..##.', '.##..##.', '.##..##.', '.######.'],
  back: ['....#...', '...##...', '..###...', '.#######', '.#######', '..###...', '...##...', '....#...'],
} as const;

export type GlyphName = keyof typeof GLYPHS;

export function Glyph({ name, size = 24, className }: { readonly name: GlyphName; readonly size?: number; readonly className?: string }): React.JSX.Element {
  const rows = GLYPHS[name];
  const rects: React.JSX.Element[] = [];
  rows.forEach((row, y) => {
    for (let x = 0; x < row.length; x += 1) {
      if (row[x] === '#') rects.push(<rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} />);
    }
  });
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 8 8" shapeRendering="crispEdges" fill="currentColor" aria-hidden="true" focusable="false">
      {rects}
    </svg>
  );
}
